import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication.service';
import { SapiService, SapiEntity, SapiError } from '../../../services/sapi.service';
import { PublicationService } from '../../../services/publication.service';
import { OverlayService } from '../../../services/overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { NgForm, UntypedFormGroup } from '@angular/forms';
import { BbSelectOption } from './../../shared/bb-select/bb-select.component';
import { Subscription } from 'rxjs';
import { Publication } from '../../../interfaces/publication';
import { Mediaclip, MediaclipAsset } from '../../../interfaces/mediaclip';
import { Router } from '@angular/router';

export interface SupportedMediaTypes {
	video?: string[];
	audio?: string[];
	document?: string[];
}
@Component({
	selector: 'upload-transcode-thirdparty-livestream',
	templateUrl: './upload-transcode-thirdparty-livestream.component.html',
	styleUrls: ['./upload-transcode-thirdparty-livestream.component.scss']
})
export class UploadTranscodeThirdPartyLivestreamComponent implements OnInit, OnDestroy {
	@ViewChild('formRef', { static: true }) form: NgForm;

	streamTypes: BbSelectOption[] = [
		{
			label: this.translate.instant('VIDEO'),
			value: 'video',
			default: true
		},
		{
			label: this.translate.instant('AUDIO'),
			value: 'audio'
		}
	];
	supportedMediaTypes: SupportedMediaTypes;
	mediatypes: BbSelectOption[];

	putRight = false;

	title: string;
	src: string;
	streamType = 'video';
	mediaType: string;
	bandwidth: number;
	width: number;
	height: number;

	subscriptions: Subscription;

	private formGroup: UntypedFormGroup;

	constructor(
		private publicationService: PublicationService,
		private authenticationService: AuthenticationService,
		private sapiService: SapiService,
		private translate: TranslateService,
		private overlayService: OverlayService,
		private router: Router) {
		this.subscriptions = new Subscription();
		this.authenticationService.hasPermission('put').subscribe(hasRight => this.putRight = hasRight);
		this.subscriptions.add(this.publicationService.getData().subscribe((publication: Publication) => {
			if (publication && publication.supportedMediaTypes) {
				this.supportedMediaTypes = publication.supportedMediaTypes;
				this.mediatypes = this.determineMediatypes();
			}
		}));
	}

	ngOnInit() {
		if (this.form && this.form instanceof NgForm && this.form.form) {
			this.formGroup = this.form.form;
		}
	}
	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	determineMediatypes() {
		const mediatypesToReturn = (this.supportedMediaTypes[this.streamType]) ? this.supportedMediaTypes[this.streamType] : [];

		if (mediatypesToReturn.length >= 1) {
			this.mediaType = mediatypesToReturn[0];
		}

		return mediatypesToReturn.map((mediatype: string, i: number) => ({
			label: mediatype,
			value: mediatype,
			default: i === 0
		}));
	}

	createLiveStream(ev: Event) {
		ev.preventDefault();

		if (this.formGroup && !this.formGroup.valid) {
			this.overlayService.createToast(this.translate.instant('COULD_NOT_SAVE_ENTITY_BECAUSE_REQUIRED_FIELDS2',
				{ entity: this.translate.instant('STREAM').toLowerCase() }), 'times-circle');

			return;
		}

		const mediaclip: Mediaclip = {
			title: this.title,
			sourcetype: 'live'
		};

		const stream: MediaclipAsset = {
			src: this.src,
			bandwidth: (this.bandwidth && this.bandwidth.toString()) || null,
			mediatype: this.mediaType
		};

		if (this.streamType === 'video' && this.width && this.height) {
			stream.width = this.width.toString();
			stream.height = this.height.toString();
		}

		mediaclip.assets = [stream];

		this.sapiService.postUrl('/mediaclip', mediaclip).subscribe(
			(res: SapiEntity) => {
				if (res.id) {
					this.router.navigate(['/library/mediaclip', res.id, 'streams']);
				}
			},
			(err: SapiError) => {
				this.overlayService.createToast(this.translate.instant('ERROR_CREATING_ENTITY',
					{ entity: this.translate.instant('STREAM').toLowerCase() }), 'times-circle');
			}
		);
	}
}
